import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledAutoRenewPackageInfo = styled('div')`
  display: flex;
  gap: 8px;
  flex-direction: column;
  .auto-renew-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .auto-renew-status-on {
      display: flex;
      align-items: center;
      cursor: pointer;
      .auto-renew-status {
        color: ${COLOR.darkGray};
        font-size: 14px;
        font-weight: 700;
      }
    }
    .auto-renew-status-off {
      display: flex;
      align-items: center;
      .auto-renew-status {
        color: ${COLOR.darkGray};
        font-size: 14px;
        font-weight: 700;
      }
    }
  }
  .auto-renew-content {
    background: ${COLOR.charcoal};
    border-radius: 8px;
    display: flex;
    padding: 12px;
    flex-direction: column;
    gap: 8px;
    .content-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: ${COLOR.darkGray};
      font-size: 14px;
      .title {
        font-weight: 400;
      }
      .content {
        font-weight: 700;
        display: flex;
        align-items: center;
      }
    }

    .button-subscription {
      display: flex;
      height: 40px;
      padding: 8px 12px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      align-self: stretch;
      border-radius: 12px;
      border: 1px solid rgba(30, 22, 78, 0.32);
      background: white;
      text-transform: none;
    }
  }
`;
